import { Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows, faLinux } from '@fortawesome/free-brands-svg-icons';
import { faLaptop } from '@fortawesome/free-solid-svg-icons';

export default function DriveInfoCard({ device }) {
  const isWindows = device.os?.toLowerCase().includes('windows');
  const osIcon = isWindows ? faWindows : faLinux;
  const osIconColor = isWindows ? '#00B0FF' : '#202224';

  return (
    <div className="bg-white rounded-xl shadow-md p-4 md:p-6 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between w-full">
      <div className="flex gap-4 items-center">
        <FontAwesomeIcon icon={faLaptop} style={{ color: '#595C60', fontSize: '24px' }} />
        <div>
          <Typography
            style={{
              fontFamily: 'Nunito Sans, sans-serif',
              fontSize: '24px',
              fontWeight: 700,
              color: '#202224',
            }}
          >
            {device.name || 'Unknown Device'}
          </Typography>
          <Typography style={{ color: '#595C60', fontSize: '14px', marginTop: '5px' }}>
            <FontAwesomeIcon icon={osIcon} color={osIconColor} className="mr-2" />
            {device.os || 'Unknown OS'}
          </Typography>
        </div>
      </div>
    </div>
  );
}